export default __webpack_public_path__ + "static/media/icn_map_pin_attended.32e67533.svg";